/**
 * Version of the demo data the stores persist under the `twiva.` localStorage
 * prefix. Bump it whenever mock data or image paths change in a way that
 * leaves previously saved entries stale (for example, avatars pointing at
 * images that no longer exist). Each visitor's saved demo data is then cleared
 * once, on their next load.
 */
const DEMO_DATA_VERSION = 2;
const VERSION_KEY = 'twiva.demoDataVersion';
const STORE_PREFIX = 'twiva.';

/** Clear demo data saved under an older version. Call before the first render. */
export function resetStaleDemoData(): void {
  try {
    if (localStorage.getItem(VERSION_KEY) === String(DEMO_DATA_VERSION)) return;
    Object.keys(localStorage)
      .filter((key) => key.startsWith(STORE_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
    localStorage.setItem(VERSION_KEY, String(DEMO_DATA_VERSION));
  } catch {
    // Storage unavailable (private mode) — nothing was persisted to clear.
  }
}
